module.exports = __webpack_public_path__ + "static/img/hs_cj_1.77f058b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hs/hs_cj_1.png
// module id = w45V
// module chunks = 1